import { useNavigate } from 'react-router-dom'

import routePath from 'router/routePath'

// React Router keeps the index of the current history entry in
// history.state.idx (0 for the entry the app was opened on). It is not part of
// the public API, but React Router has no public way to tell whether going back
// stays in the app: location.key === 'default' is not enough, because a
// redirect on the first entry replaces the key while the index stays 0.
const hasPreviousViewInApp = () =>
  ((window.history.state as { idx?: number } | null)?.idx ?? 0) > 0

export const useReturnToPreviousView = () => {
  const navigate = useNavigate()

  return () => {
    if (hasPreviousViewInApp()) {
      navigate(-1)
    } else {
      navigate(routePath.root, { replace: true })
    }
  }
}
